import { useAuthentication } from '@psyomics/ui-common';
import { AppBar, Breadcrumb, LoadingSpinner } from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router-dom';

function SecureLayout() {
  const { isAuthenticated, logout, isLoading } = useAuthentication();
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!isLoading && !isAuthenticated) {
    throw new Error('User is not authenticated');
  }

  const menuItems = [
    { id: 'account', label: t('page.account.title'), onClick: () => navigate('/account') },
    { id: 'signout', label: t('page.account.signOut'), onClick: () => logout() },
  ];

  return (
    <div className="flex min-h-dvh flex-col">
      <AppBar logoHref={'/'} menuItems={menuItems} />
      <main className="flex min-h-0 flex-1 flex-col">
        <div className="bg-gray-50 min-h-screen pt-8">
          <div className="container max-w-5xl mx-auto px-4">
            {isLoading ? (
              <LoadingSpinner />
            ) : (
              <>
                <Breadcrumb />
                <Outlet />
              </>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}

export { SecureLayout };
